import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { modalActions } from 'store/modal'
import { getBaseSiteIdFromStudy, getUserRoleByStudy, getUserRoleIdByStudy, hasPiiRole } from 'utils/misc'
import { USER_ROLES_WITH_SCHEDULE_VIRTUAL_VISIT_PERMISSION, USER_ROLE_ID_MAP, SITE_ROLE_IDS } from 'utils/constants'
import { checkUserHasScope } from 'utils/userUtils'
import VisitSchedulesPage from '../components/VisitSchedulesPage'
import { actions } from '../modules/VisitSchedules'
import { isIrtControlledVisitRestricted, isVersionUatOrLive } from '../../../../../../../../../utils/studyConfigUtils'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { params } = ownProps
  const { studyID } = params
  const { loading, location, searchTerm, study, user, visitSchedules, studyLock } = state
  const { currentStudy, studyVersionList } = study
  const { visitScheduleTranslations } = visitSchedules
  const { translations } = visitScheduleTranslations
  const enforcedLanguage = currentStudy?.config?.enforced_language
  const adhocVisitsDisabled = currentStudy?.config?.visit_support?.disable_adhoc_visit
  const requireMissedVisitReason = currentStudy?.config?.require_missed_visit_reason

  const siteID = getBaseSiteIdFromStudy(study)

  const userRole = getUserRoleByStudy(user, studyID)
  const roleId = getUserRoleIdByStudy(user, studyID)

  const isVisitCycleSupported = currentStudy?.config?.visit_support?.version > 1
  const isArmsSupported = currentStudy?.config?.visit_support?.arms_enabled

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)
  const studyConfig = currentStudy?.config

  const isIrtControlledVisit = (visitId, participantVisitMetadata, studyScheduleVisitId) =>
    isIrtControlledVisitRestricted({
      config: studyConfig,
      studyVersionList,
      studyVersionID,
      roleId,
      visitId,
      participantVisitMetadata,
      studyScheduleVisitId,
      studyVisitSchedule: visitSchedules?.studyVisitSchedule,
    })

  const lowercasedRoles = USER_ROLES_WITH_SCHEDULE_VIRTUAL_VISIT_PERMISSION.map(role => role.toLowerCase())
  const canEditVisits = lowercasedRoles.includes(userRole?.toLowerCase())

  return {
    adhocVisitsDisabled,
    canEditVisits,
    isSiteCoord:
      roleId === USER_ROLE_ID_MAP.siteCoordinator ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinator ||
      roleId === USER_ROLE_ID_MAP.siteCoordinatorUAT ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinatorUAT ||
      roleId === USER_ROLE_ID_MAP.siteCoordinatorDEV ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinatorDEV,
    isUpcomingTabVisible:
      SITE_ROLE_IDS.includes(user.permissions[studyID].role_id) &&
      checkUserHasScope({ user, studyId: studyID, scope: ['rppv'] }),
    isPreviousTabVisible:
      SITE_ROLE_IDS.includes(user.permissions[studyID].role_id) &&
      checkUserHasScope({ user, studyId: studyID, scope: ['rppv'] }),
    loading,
    location,
    searchTerm,
    siteID,
    studyID,
    visitSchedules: visitSchedules || {},
    studyLock,
    hasPiiRole: hasPiiRole(userRole),
    translations,
    enforcedLanguage,
    requireMissedVisitReason,
    isVisitCycleSupported,
    isArmsSupported,
    isReadOnlyState,
    studyVersionID,
    isIrtControlledVisit,
  }
}

const mapDispatchToProps = { ...actions, ...modalActions }

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  const { loading } = props
  if (loading.general) {
    return <Loader />
  }
  return <VisitSchedulesPage {...props} />
})
